angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("footer-template.html", "<footer class=\"main\"> <div class=\"bottom-toolbar\" ng-if=\"impersonating\"> <button class=\"btn btn-info btn-logout\" ng-click=\"exitImpersonation()\" title=\"Back to admin\"> <i class=\"fa fa-sign-out\" aria-hidden=\"true\"></i> </button>\n<span class=\"text\">Impersonating <strong class=\"username\">{{user.username}}</strong></span> </div> <talk-widget></talk-widget> </footer>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/footer-template.html
 ** module id = 83
 ** module chunks = 0
 **/